// Reads the OS-level prefers-reduced-motion setting. Guarded for jsdom (no matchMedia).
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
